export default __webpack_public_path__ + "static/media/products.a6cb0df3.svg";